import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';
import { Modal } from '../common/Modal';

type Props = {
  isOpen: boolean;
  title: string;
  message: ReactNode;
  onClose: () => void;
  onConfirm: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmDisabled?: boolean;
  confirmVariant?: 'primary' | 'danger';
  multiline?: boolean;
};

export default function ConfirmDialog({
  isOpen,
  title,
  message,
  onClose,
  onConfirm,
  confirmLabel,
  cancelLabel,
  confirmDisabled = false,
  confirmVariant = 'primary',
  multiline = false,
}: Props) {
  const { t } = useTranslation();
  const resolvedConfirmLabel = confirmLabel ?? t('common.yes');
  const resolvedCancelLabel = cancelLabel ?? t('common.no');
  const confirmClassName =
    confirmVariant === 'danger' ? 'app-modal__btn app-modal__btn--danger' : 'app-modal__btn app-modal__btn--confirm';

  return (
    <Modal
      open={isOpen}
      title={title}
      boxClassName="app-modal--sm"
      showCloseButton={false}
      overlayZIndex={1100}
      portal
      onClose={onClose}
    >
      <p className="app-modal__message" style={multiline ? { whiteSpace: 'pre-line' } : undefined}>
        {message}
      </p>
      <div className="app-modal__actions">
        <button className="app-modal__btn app-modal__btn--cancel" type="button" onClick={onClose}>
          {resolvedCancelLabel}
        </button>
        <button className={confirmClassName} type="button" disabled={confirmDisabled} onClick={onConfirm}>
          {resolvedConfirmLabel}
        </button>
      </div>
    </Modal>
  );
}
